class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.initialPredectiveSearch = "";

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      "click",
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  open(event) {
    const predectiveSearchResults = document.querySelector(
      "[data-predictive-search]"
    );

    if (predectiveSearchResults)
      this.initialPredectiveSearch = predectiveSearchResults.cloneNode(true);

    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    const ffTemplateSearch = document.querySelector(".ff-template-search");
    if (!ffTemplateSearch) {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      this.detailsContainer.classList.add("ff-closing-search");
      setTimeout(() => {
        this.detailsContainer.removeAttribute("open");
        document.body.removeEventListener("click", this.onBodyClickEvent);
        document.body.classList.remove("overflow-hidden");
        document.body.removeAttribute("style");
        const predectiveSearch = document.querySelector("predictive-search");
        predectiveSearch.querySelector("#Search-In-Modal").value = "";
        predectiveSearch.removeAttribute("results");
        predectiveSearch
          .querySelector("#Search-In-Modal")
          .setAttribute("aria-activedescendant", "");
        predectiveSearch.removeAttribute("loading");
        predectiveSearch
          .querySelector("#Search-In-Modal")
          .setAttribute("aria-expanded", false);
        predectiveSearch.resultsMaxHeight = false;
        predectiveSearch
          .querySelector("[data-predictive-search]")
          .removeAttribute("style");

        predectiveSearch.querySelector("[data-predictive-search]").innerHTML =
          this.initialPredectiveSearch.innerHTML;

        this.detailsContainer.classList.remove("ff-closing-search");
      }, 590);
    }
  }
}

customElements.define("details-modal", DetailsModal);
